import { Reactivation as ReactivationComponent } from '@ltvco/refresh-lib/payments';
import { useFeatureIsOn } from '@ltvco/refresh-lib/vendors';
import { useEffect } from 'react';

export function Reactivation({
  changeIsInReactivationRedesignVariation,
}: {
  // eslint-disable-next-line no-unused-vars
  changeIsInReactivationRedesignVariation: (variation: boolean) => void;
}) {
  const userInReactivationRedesignTest = useFeatureIsOn('RTRN-867');

  useEffect(() => {
    changeIsInReactivationRedesignVariation(userInReactivationRedesignTest);
    return () => {
      changeIsInReactivationRedesignVariation(false);
    };
  }, [userInReactivationRedesignTest, changeIsInReactivationRedesignVariation]);

  return (
    <div>
      <ReactivationComponent
        userInReactivationRedesignTest={userInReactivationRedesignTest}
      />
    </div>
  );
}
